<div class="card card-custom" [ngClass]="{ 'kt-portlet&#45;&#45;body-progress' : viewLoading, 'kt-portlet&#45;&#45;body-progress-overlay' : loadingAfterSubmit }">
    <div class="card-header" *ngIf="participant">
        <div class="card-title">
            <h3 class="card-label">{{getTitle()}}</h3>
        </div>
    </div>
    <div *ngIf="participant">
        <form [formGroup]="participantForm" class="form form-group-seperator-dashed">
            <div class="card-body">

                <div class="card-body-progress">
                    <mat-spinner [diameter]="20"></mat-spinner>
                </div>

                <kt-alert *ngIf="hasFormErrors" type="warn" [duration]="30000" [showCloseButton]="true" (close)="onAlertClose($event)">
                    Oops! It looks like you’ve forgotten some important information.
                </kt-alert>

                <div class="form-group kt-form__group row">
                    <div class="col-lg-6 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <mat-select placeholder="Participant Side" formControlName="participants_side">
                                <mat-option *ngFor="let participant of participantsSide;" [value]="participant.value">{{participant.name}}</mat-option>
                            </mat-select>
                            <mat-error>
                                Participant Side
                                <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-6 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput
                                   placeholder="Participant Full Name"
                                   [(ngModel)]="participant.participants_names"
                                   formControlName="participants_names"/>
                            <mat-error>Participant full name
                                <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="form-group kt-form__group row">
                    <div class="col-lg-12 kt-margin-bottom-20-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <textarea rows="4" type="text" placeholder="Extra Note"
                                   matInput
                                   [(ngModel)]="participant.participants_descr"
                                   formControlName="participants_descr">
                            </textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="card-footer p-0 b-0">
                <div class="form-actions form-actions-solid">
                    <div class="row text-right">
                        <div class="col-lg-12">
                            <button type="button" mat-raised-button [mat-dialog-close]="data.animal" cdkFocusInitial matTooltip="Close">
                                Close
                            </button>&nbsp;
                            <button type="button" [disabled]="!isNameValid()" class="btn btn-success" mat-raised-button color="submit" (click)="onSubmit()" [disabled]="viewLoading"
                                    matTooltip="Save changes">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
